/** Remove tudo que não for dígito. */
export const somenteDigitos = (valor: string): string => (valor || '').replace(/\D/g, '');

/**
 * Formata a chave da NF-e apenas para exibição, agrupando os 44 dígitos
 * em blocos de 4. NUNCA deve ser persistida: o banco guarda os dígitos crus.
 */
export const formatarChaveNfe = (valor?: string | null): string => {
  const digitos = somenteDigitos(valor || '').slice(0, 44);
  return digitos.replace(/(\d{4})(?=\d)/g, '$1 ');
};
